import React, { Component } from 'react';

class LatestNewsSection extends Component{
	render(){
		
		return(
			<>
				
				<section className="section-sp1 service-wraper2">
					<div className="container">
						<div className="row">
							<div className="col-xl-12 col-sm-12 mb-12 text-center">
								<div className='heading-bx'>
									<h6 class="title-ext text-secondary">Achieve</h6>
									<h1 style={{fontSize:"48px"}}>Our Achievements</h1>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-xl-3 col-sm-6 mb-30">
								<div className="feature-container feature-bx3">
									<h2 className="counter text-secondary">20+</h2>
									<h5 className="counter-title">Years With You</h5>
									<p>A decade of trusted, compassionate, and reliable healthcare services.</p>
								</div>
							</div>
							<div className="col-xl-3 col-sm-6 mb-30">
								<div className="feature-container feature-bx3">
									<h2 className="counter text-secondary">50+</h2>
									<h5 className="counter-title">Awards</h5>
									<p>Recognized for outstanding performance in medical care, high service quality, and innovative practices.</p>
								</div>
							</div>
							<div className="col-xl-3 col-sm-6 mb-30">
								<div className="feature-container feature-bx3">
									<h2 className="counter text-secondary">60+</h2>
									<h5 className="counter-title">Expert Doctors</h5>
									<p>Skilled and dedicated professionals ready to serve your health needs.</p>
								</div>
							</div>
							<div className="col-xl-3 col-sm-6 mb-30">
								<div className="feature-container feature-bx3">
									<h2 className="counter text-secondary">500+</h2>
									<h5 className="counter-title">Satisfied Client</h5>
									<p>Hundreds of happy patients who trust Avenra for their health and well-being.</p>
								</div>
							</div>
						</div>
					</div>
				</section>
				
			</>
		);
	}
}

export default LatestNewsSection;